import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';
import ReplyEditorVM from './reply';
import './standaloneReply.html';
import { TextThreadEditorVMConfig } from '../textThread';

const focusedEditor: Observable<StandaloneReplyEditorVM | undefined> = ko.observable();

components.preload('reply-suggestion');
components.preload('open-ai-completion');

@injectable()
export default class StandaloneReplyEditorVM extends ReplyEditorVM {
    isActive = ko.observable(false);

    oReplaySuggestionRef = ko.observable(null);

    constructor(
        @inject(wccModules.componentConfig) model: TextThreadEditorVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(model, info, storage, ctx, effects);

        const hasContent = ko.pureComputed(() => this.text().length > 0 || this.attachments().length > 0 || this.uploads().length > 0);
        const hasFocus = this.textEditor.pluck(e => e.hasFocus, false);

        effects.register((hasFocus: boolean) => {
            if (hasFocus)
                focusedEditor(this);
        }, [hasFocus]);

        effects.register((focusedEditor, hasContent) => {
            this.isActive(focusedEditor === this || hasContent);
        }, [focusedEditor, hasContent]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'reply-editor-standalone': true
            }
        }, this);
    }

    protected override reset() {
        super.reset();

        this.textEditor()?.blur();

        if (focusedEditor() === this)
            focusedEditor(undefined);
    }

    protected override getState() {
        if (this.isActive())
            return super.getState();

        return {};
    }

    protected override checkIfAllowedToCancel() {
        return super.checkIfAllowedToCancel() || this.isActive();
    }
}